import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-front-banner',
  templateUrl: './front-banner.component.html',
  styleUrls: ['./front-banner.component.scss']
})
export class FrontBannerComponent implements AfterViewInit {

  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

  ngAfterViewInit(): void {
      this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/app/banner/get", data: {uuid: this.company_uuid}},
          disabled_pagenat: true,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Title', type: 'string', key: 'title'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo' + (this.company_uuid ? '/' + this.company_uuid : '/null') + "/front/banner/form", hide: true},
            {label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_banner_view', title: 'title', hide: true},
          ]}
      this.tb.init(setting);
      setTimeout(() => {
       // this.cdr.detectChanges();
      }, 100)
  }

}
